import { toast } from 'react-toastify';
import { path } from '@/routes/Routes.helpers';
import { SUCCESS_NOTIFY } from '@/configs/codes';
import { deleteCookie } from '@/helpers/storage';
import { isTelegramApp } from '@/helpers/utils';

const TIMEOUT_DELAY = 2000;

export const logout = async (isSilent?: boolean): Promise<void> => {
    deleteCookie('token');
    deleteCookie('refreshToken');
    deleteCookie('userGuid');

    if (!isSilent) {
        toast.success(SUCCESS_NOTIFY.s103);
    }

    setTimeout(() => {
        if (!isTelegramApp()) {
            window.location.href = path('root');
        }
    }, TIMEOUT_DELAY);
};
